export default __webpack_public_path__ + "static/media/refer.09ad3072.png";